export default {
    Metadata: {
        Name: "Exp",
        Description: "Returns Euler\'s number (Napier\'s constant) to the power of the  given number.",
        Syntax: "Exp(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(floatValue) {
        return Math.exp(floatValue);
    },
};

